import classNames from 'classnames';
import { useContext } from 'react';
import { useStore } from 'zustand';

import { LegacyHotelContext } from 'app/context/HotelContext/LegacyHotelContext';
import {
  eachDayOfInterval,
  format,
  isSunday,
  isWithinInterval,
} from 'app/utils/dayjs';

import { inventoryStore } from '../../InventoryStore';
import { RowTitleCell } from '../Cells/_components/RowTitleCell';

export const TimePeriod = () => {
  const { publishedPackages } = useContext(LegacyHotelContext);

  const minimumDiscountOverrideDates = new Set<string>(
    publishedPackages
      .filter((pkg) => pkg.minimumDiscountOverride)
      .flatMap((pkg) =>
        pkg.minimumDiscountOverrideDates.map((d) => new Date(d).toDateString())
      )
  );

  const timePeriod = useStore(inventoryStore, (state) => state.formTimePeriod);
  const currentDuplicateHoverRange = useStore(
    inventoryStore,
    (state) => state.currentDuplicateHoverRange
  );

  const isDuplicateHovered = (date: Date) =>
    currentDuplicateHoverRange &&
    isWithinInterval(date, currentDuplicateHoverRange);

  const dates = eachDayOfInterval({
    start: timePeriod.startDate,
    end: timePeriod.endDate,
  }).map((date) => `${date}`);

  const isOverriddenDay = (date: Date) =>
    minimumDiscountOverrideDates.has(date.toDateString());

  return (
    <div className="time-period">
      <RowTitleCell value="Time Period" />
      {dates.map((date) => (
        <div
          key={date}
          className={classNames('time-period-date-cell', {
            'bold-border': isSunday(new Date(date)),
            'hover-duplication': isDuplicateHovered(new Date(date)),
            'minimum-discount-date': isOverriddenDay(new Date(date)),
          })}
        >
          <div className="week-day">{format(new Date(date), 'ddd')}</div>
          <div className="date">{format(new Date(date), 'DD/MM')}</div>
        </div>
      ))}
    </div>
  );
};
